// Globals
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { FormItem, useWatchForm } from '@/components';
import { Input } from '@/ui';

// Store
import { useAppState } from '@/store';

// Modules
import { ChannelsSelect, selectChannels } from '@/modules/Channels';

// Hooks
import { useGetRequiredRule } from '@/hooks';

// Helpers
import { WebsiteFieldsNames } from '../../helpers';

type TWebsiteChannelBlockProps = {
  disabled?: boolean;
};

const WebsiteChannelBlock: FC<TWebsiteChannelBlockProps> = ({ disabled }) => {
  const { t } = useTranslation(['common']);
  const requiredRule = useGetRequiredRule({ t });
  const channels = useAppState(selectChannels);
  const channelId = useWatchForm(WebsiteFieldsNames.CHANNEL);

  const selectedChannel = useMemo(() => channels?.find((channel) => channel.id === channelId), [channelId, channels]);

  return (
    <>
      <FormItem name={WebsiteFieldsNames.CHANNEL} rules={[requiredRule]} label={t('label_channels')}>
        <ChannelsSelect disabled={disabled} />
      </FormItem>
      {selectedChannel?.siteUrl && (
        <FormItem label={t('label_link')}>
          <Input value={selectedChannel.siteUrl} disabled />
        </FormItem>
      )}
    </>
  );
};

export default WebsiteChannelBlock;
